import React from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Input,
  FormGroup,
} from "reactstrap"

import PlayYouTubeVideo from "components/Modals/PlayYouTubeVideo.js"

//core components
import SimpleHeader from "components/Headers/SimpleHeader.js"

import videoCatalog from "data/videoCatalog.js"

const normalize = (text) =>
  text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")

class VideoCatalog extends React.Component {
  state = {
    search: "",
    modalPlayVideoTitle: "",
    modalPlayYouTubeVideoOpened: false,
    videoSource: "",
  }

  playYouTubeVideo(e, topic) {
    e.preventDefault()
    this.setState({
      modalPlayVideoTitle: topic.text,
      modalPlayYouTubeVideoOpened: true,
      videoSource: topic.videoLink,
    })
  }

  modalYouTubeVideoClose(e) {
    this.setState({
      modalPlayVideoTitle: "",
      modalPlayYouTubeVideoOpened: false,
      videoSource: "",
    })
  }

  render() {
    const term = normalize(this.state.search.trim())

    const filteredCatalog = videoCatalog
      .map((group) => ({
        playlist: group.playlist,
        slug: group.slug,
        topics: group.topics.filter(
          (topic) => term === "" || normalize(topic.text).includes(term)
        ),
      }))
      .filter((group) => group.topics.length > 0)

    return (
      <>
        <style>{`
          .videoCatalogGrupo {
            display: flex;
            flex-wrap: wrap;
            background-color: #000;
            border-radius: 6px;
            overflow: hidden;
            margin-bottom: 24px;
          }
          .videoCatalogGrupoFoto {
            flex: 0 0 260px;
            max-width: 260px;
            min-height: 220px;
            background-size: cover;
            background-position: center;
          }
          .videoCatalogGrupoConteudo {
            flex: 1 1 300px;
            padding: 24px 28px;
          }
          .videoCatalogGrupoTitulo {
            background-color: #FF0000;
            color: #fff;
            font-weight: bold;
            font-size: 20px;
            padding: 4px 10px;
            display: inline-block;
            margin-bottom: 16px;
          }
          .videoCatalogItem {
            list-style: none;
            margin-bottom: 10px;
          }
          .videoCatalogGrupoConteudo a.videoCatalogLink,
          .videoCatalogGrupoConteudo a.videoCatalogLink:visited {
            color: #fff !important;
            text-decoration: underline;
            font-size: 16px;
          }
          .videoCatalogGrupoConteudo a.videoCatalogLink:hover {
            color: #FF0000 !important;
          }
          .videoCatalogRodape {
            text-align: center;
            padding: 20px 0;
          }
          .videoCatalogRodape img {
            height: 32px;
            margin: 0 16px;
            filter: invert(1);
          }
        `}</style>
        <SimpleHeader
          name="Catálogo de Vídeos"
          items={[
            { level: "parent", name: "Dashboards" },
            { level: "nav", name: "Catálogo de Vídeos" },
          ]}
        />
        <Container className="mt--6" fluid>
          <Card>
            <CardHeader>
              <Row>
                <Col xs="12">
                  <h5 className="h3 mb-0">
                    Vídeos de treinamento, organizados por área
                  </h5>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <FormGroup style={{ maxWidth: "400px" }}>
                <Input
                  type="text"
                  placeholder="Buscar tópico..."
                  autoComplete="off"
                  value={this.state.search}
                  onChange={(e) => this.setState({ search: e.target.value })}
                />
              </FormGroup>

              {filteredCatalog.length === 0 && (
                <p className="text-muted">Nenhum tópico encontrado.</p>
              )}

              {filteredCatalog.map((group) => (
                <div className="videoCatalogGrupo" key={group.playlist}>
                  <div
                    className="videoCatalogGrupoFoto"
                    style={{
                      backgroundImage: `url(/img/videoCatalog/bg-${group.slug}.jpg)`,
                    }}
                  />
                  <div className="videoCatalogGrupoConteudo">
                    <div className="videoCatalogGrupoTitulo">
                      {group.playlist}
                    </div>
                    <ul style={{ paddingLeft: 0 }}>
                      {group.topics.map((topic, index) => (
                        <li className="videoCatalogItem" key={index}>
                          <a
                            className="videoCatalogLink"
                            href={"#playYTVideo"}
                            onClick={(e) => this.playYouTubeVideo(e, topic)}
                          >
                            {topic.text}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}

              <div className="videoCatalogRodape">
                <img src="/img/videoCatalog/sap.png" alt="SAP Business One" />
                <img src="/img/videoCatalog/golive.png" alt="Golive" />
              </div>
            </CardBody>
          </Card>
        </Container>
        <PlayYouTubeVideo
          title={this.state.modalPlayVideoTitle}
          modalClose={this.modalYouTubeVideoClose.bind(this)}
          modalOpened={this.state.modalPlayYouTubeVideoOpened}
          source={this.state.videoSource}
        />
      </>
    )
  }
}

export default VideoCatalog
